export var MatchConfidence = /*#__PURE__*/ function(MatchConfidence) {
    MatchConfidence["High"] = "high";
    MatchConfidence["Medium"] = "medium";
    MatchConfidence["Low"] = "low";
    return MatchConfidence;
}({});
